import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AddCompanyUser = () => {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [familyName, setFamilyName] = useState('');
    const [role, setRole] = useState('student');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [companyName, setCompanyName] = useState('');

    useEffect(() => {
        // Fetch company info when component mounts
        const fetchCompanyInfo = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setError('Unauthorized. Please log in.');
                    return;
                }

                // Fetch the logged-in company admin's info to display the company name
                const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/me`, {
                    headers: {
                        'x-auth-token': token,
                    },
                });

                if (res.status === 200) {
                    setCompanyName(res.data.companyName || ''); // Assume companyName is in the response
                }
            } catch (error) {
                console.error('Error fetching company info:', error);
                setError('Error fetching company info.');
            }
        };

        fetchCompanyInfo();
    }, []);

    const handleUserAddCompany = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setError('Unauthorized. Please log in.');
                return;
            }

            // Make API request to add a new user
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/users/add`, {
                email,
                firstName,
                familyName,
                role,
            }, {
                headers: {
                    'x-auth-token': token,
                },
            });

            if (res.status === 201) {
                setMessage('User added successfully');
                setEmail('');
                setFirstName('');
                setFamilyName('');
                setRole('student');
            }
        } catch (error) {
            console.error('Error adding user:', error);
            if (error.response && error.response.data.error) {
                setError(error.response.data.error);
            } else {
                setError('Error adding user');
            }
        }
    };

    return (
        <div>
            <h2>Add New User</h2>
            {companyName && <p>Adding user to company: <strong>{companyName}</strong></p>}
            <form onSubmit={handleUserAddCompany}>
                <div>
                    <label>Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>First Name:</label>
                    <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Last Name:</label>
                    <input
                        type="text"
                        value={familyName}
                        onChange={(e) => setFamilyName(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Role:</label>
                    <select value={role} onChange={(e) => setRole(e.target.value)}>
                        <option value="student">Company User</option>
                    </select>
                </div>
                <button type="submit">Add User</button>
            </form>
            {message && <p style={{ color: 'green' }}>{message}</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
};

export default AddCompanyUser;
